<!--
    수임사건 상세조회
    레포트 : via_suim_detail_front_all.crf
    엑  셀 : /proc_excel/N_REPORT_VIA_DTL
    목  록 : /proc/N_REPORT_VIA_DTL
-->
<template>
  <div class="content">
    <c회원선택2 ref="selectCust" @select="selectCust" :memblist=selectCustList  />
    <s-location report title="수임사건 상세 조회"/>
		<!-- <h4 class="sub_title02">수임사건 상세 조회</h4> -->

      <div class="btn_group mt0">
        <div class="right">
          <span v-if="reportYn == 'N'">
            <button @click="initData" class="btn icon reload">초기화</button>
            <button @click="doSearch" class="btn icon search_black">검색</button>
            <button @click.prevent="$refs.excel.down()" class="btn icon excel">엑셀 다운</button>
            <button @click="doReport" class="btn icon print">미리보기</button>
          </span>
          <button v-else @click="reportYn = 'N'" class="btn icon reload">돌아가기</button>
        </div>
    	</div>

    <div v-if="reportYn == 'N'">

      <table class="tbl01 sch_tbl">
        <tr>
          <th>조회일자</th>
          <td>
            <select v-model="search.iv_searchdtgbn">
              <option value="C">수임일</option>
              <option value="V">경유일</option>
            </select> &nbsp;
            <i-input-date input-class="w_inputno" title="시작일" v-model="search.iv_viadtfr" :placeholder="search.iv_viadtfr"/>
          ~ <i-input-date input-class="w_inputno" title="종료일" v-model="search.iv_viadtto" :placeholder="search.iv_viadtto"/>
            <br class="mobile"/>
            <s-date-range :fr.sync="search.iv_viadtfr" :to.sync="search.iv_viadtto" />
          </td>
        </tr>
        <tr>
          <th>조회범위</th>
          <td>
            <label><input type="radio" v-model="search.iv_extfree_yn" value="N" />전체</label> &nbsp;
            <label><input type="radio" v-model="search.iv_extfree_yn" value="Y" />면제 및 연결사건 제외</label>
          </td>
        </tr>
        <tr v-if="$store.state.session.user.type == 'master'">
          <th>조회대상</th>
          <td>
            <label><input type="radio" v-model="search.iv_gubun" value="all"   />전체</label> &nbsp;
            <label><input type="radio" v-model="search.iv_gubun" value="select"/>담당변호사 선택</label>
          </td>
        </tr>

        <tr v-if="$store.state.session.user.type == 'master' && search.iv_gubun == 'select'">
          <th>검색할 변호사 목록</th>
          <td>
            <input type="text" v-model="search_membnm" @keydown.enter="$refs.selectCust.open('P',search_membnm,'','' )" />
            <i-btn @click="$refs.selectCust.open('P',search_membnm,'','')" class="btn xs black01 ">회원선택</i-btn>

            <div class="damdang_wrap">
              <!-- div 팝업 :: 담당 변호사 검색 결과-->
              <table class="tbl01 list01">
                <tr>
                  <th width="60">등록번호</th>
                  <th>회원명</th>
                  <th>구분</th>
                </tr>
                <tr v-for="(item, i) in selectCustList" :key="i">
                  <td>{{ item.membno }}</td>
                  <td>{{ item.membnm }}</td>
                  <td><span class="btn xs org01 outline"  @click="delCust(item)">삭제</span></td>
                </tr>
              </table>
            </div><!--//<div class="damdang_wrap">-->
          </td>
        </tr>
      </table>

      <!-- <h4 class="sub_title02 ">수임사건 경유 내용</h4> -->

      <s-loading v-if="list.loading"/>
      <div class="scroll_wrap"> <!--모바일 스크롤 -->
        <p class="scroll_txt"> &lt;-&gt; 좌우 스크롤을 이용하세요</p>
        <div class="al_r mb5">
          페이지당 조회건수
          <select v-model="list.listSize" @change="doSearch">
            <option value="10">10건</option>
            <option value="20">20건</option>
            <option value="50">50건</option>
          </select>
        </div>
        <table class="tbl01 wide">
          <tr>
            <th class="no">순번</th>
            <th>증표종류</th>
            <th>증표번호</th>
            <th class="day">수임일</th>
            <th class="day">경유일</th>
            <th>사건유형</th>
            <th>관할기관</th>
            <th>사건번호</th>
            <th>사건명</th>
            <th>구분</th>
            <th>위임인</th>
            <th class="vianame">상대방</th>
            <th class="no">건수</th>
            <th>사임취하</th>
            <th v-if="search.iv_gubun == 'select'" class="vianame">담당변호사</th>
            <th v-else class="vianame">증표<br/>명의자</th>

            <!-- <th>공동수임건수</th> -->
            <!-- <th>담당변호인목록</th> -->
          </tr>
          <tr v-for="(item,i) in list.items" :key=i>
            <td>{{ list.totalCount - ((list.pageNo -1) * list.listSize) - i }}</td>
            <td>{{ item.caseclsfnm }}</td>
            <td>{{ item.rcptno }}</td>
            <td>{{ item.cntchargdt | moment('YY.MM.DD.') }}</td><!-- 수임일 -->
            <td>{{ item.viadt      | moment('YY.MM.DD.') }}</td><!-- 경유일 -->
            <td>{{ item.casetypenm }}</td><!-- 사건유형 -->
            <td>{{ item.isttoutplac }}</td>
            <td>{{ item.caseno }}</td>
            <td>{{ item.casenm }}</td>
            <td>{{ item.clientclsfnm }}</td>
            <td>{{ item.client }}</td>
            <td>{{ item.otherside }}</td>
            <td>{{ item.cnt }}</td>
            <td>{{ item.cancelclsfnm == '공란' ? '-' : item.cancelclsfnm }}</td>
            <td>{{ search.iv_gubun == 'select' ? item.chrgmembnm : item.membnm }}</td>

            <!-- <td>{{ item.realcnt }}</td> -->
            <!-- <td>{{ item.viamemb_list }}</td> -->
          </tr>
        </table>
      </div> <!--// scroll_wrap -->

      <div class="paging wide">
        <p class="num">
          <s-page :pageNo.sync="list.pageNo" :totalCount="list.totalCount" :listSize="list.listSize" @changePage="pageNo=>doSearch(null,pageNo)"/>
        </p>
      </div>

<s-excel ref="excel" :isDebug="false" excel-filename="수임사건 상세 조회"
   excel-api="/proc_excel/N_REPORT_VIA_DTL" result-set="rs1"
  :excel-param="()=>({ ...searchParam(), iv_pgsize: -1})"
  excel-headers="
      text                         | value            | format         | align
      순번                         | (count)
      증표종류                     | caseclsfnm
      증표번호                     | rcptno
      수임일                       | cntchargdt        | YYYY.MM.DD
      경유일                       | viadt             | YYYY.MM.DD
      사건유형                     | casetypenm
      관할기관                     | isttoutplac
      사건번호                     | caseno
      사건명                       | casenm
      구분                         | clientclsfnm
      위임인                       | client
      상대방                       | otherside
      건수                         | cnt
      사임취하                     | cancelclsfnm
      증표명의자                   | membnm
      공동수임건수                 | realcnt           | %10.2f       | center
      담당변호인목록               | viamemb_list      |              | left
      타회소속 분사무소 담당변호사 | submembersnm      |              | left
  ">

    <template v-slot:excel-css>
      table.top td { font-size: 16px; font-family: '맑은 고딕', AppleGothic, serif, sans-serif; }
    </template>

    <template v-slot:excel-top-raw="{headers}">
      <table bordr='0' class='top'>
        <tr><td :colspan=headers.length align='center' style='font-size: 20px; font-weight: bold; height: 40px;'>
          수임사건 상세조회
        </td></tr>
        <tr><td :colspan=headers.length align='center' style='font-size: 16px;'>
          ( 기간 : {{ search.iv_viadtfr }} ~ {{ search.iv_viadtto }} )
        </td></tr>
        <tr><td :colspan=headers.length style='height: 35px;'>
          성명 : {{ $store.getters['session/userDpName'] }}
        </td></tr>
      </table>
    </template>

  </s-excel>

    </div>
    <!-- // v-if = "reportYn== 'N'"-->
    <s-report :src="report" v-else/>
  </div>
</template>

<script>
let ui
export default {
  components: {
    "c회원선택2" : require('@/components/c회원선택3.vue').default,
  },
  data() {
    return {
      report : '',
      reportYn : 'N', // Y = report, N = 표
      search : {},
      search_init : {
       iv_viadtfr : this.$moment().add(-1, 'month').format("YYYY-01-01"),
       iv_viadtto : this.$moment().format("YYYY-MM-DD"),
       iv_gubun   : 'all',
       iv_searchdtgbn : 'C', // 검색날짜 : 기본 사용일
       iv_extfree_yn : 'Y', // 면제제외 여부 : N(전체), Y(면제제외)
       iv_membnos : '-', // 마스터일때 변호사목록 ( 전체는 '-' )
      },
      selectCustList : [], // 조회할 변호사목록
      search_membnm : '', // 검색할 변호사 이름

      list: {},
      list_init: {
        loading: false,
        items: [],
        totalCount: 0,
        listSize : 10,
        pageNo : 1,
      },
    }
  },
  watch : {
    '$route': 'initData',
  },
  created() {
    ui = this.$ui
    this.search = { ...this.search_init }
    this.list = { ...this.list_init }
  },
  mounted() {
  },
  methods: {
    initData(){ // 현재 메뉴 다시 클릭 시
      this.reportYn = 'N'
      this.search = T.deepCopy(this.search_init)
      this.list = T.deepCopy(this.list_init)
      this.selectCustList = []
      this.search_membnm = ''
    },

    selectCust(item) { // 담당변호사 검색추가 콜백
      if (this.selectCustList.filter(e => e.membclsf == item.membclsf && e.membno == item.membno).length > 0) {
        return ui.notify(`${ item.membnm }(${ item.membno })님은 이미 있습니다.`, {group: "top_left", type: "warn", title: "실패"})
      }

      item.membseq = this.selectCustList.length + 1
      this.selectCustList.push(item)
      ui.notify(`${ item.membnm }(${ item.membno })님을 추가했습니다.`, {group: "top_left", type: "success", title: "성공"})
      this.doSearch()
    },
    delCust(item) { // 담당변호사 검색추가한것 삭제
      //this.selectCustList = this.selectCustList.filter(e => e.membseq != item.membseq)
      this.selectCustList = this.selectCustList.filter(e => e.membno != item.membno)
      this.doSearch()
    },

    searchParam() { // 검색 파라미터
      return {
          ...this.search,
          iv_pgsize  : this.list.listSize,
          iv_page    : this.list.pageNo,
          iv_membnos : this.search.iv_gubun == "all" ? '-' : this.selectCustList.reduce((tot, item) => tot + '#' + _.trim(item.membno), '').replace(/^#/, ""),
      }
    },

    doSearch($event,pageNo){

      this.list.pageNo = pageNo != undefined ? pageNo : 1

      // if(this.search.iv_gubun=='1') {

      ui.httpGetList(this.list, '/proc/N_REPORT_VIA_DTL', this.searchParam(),
        ret => {
          this.list.totalCount = _.get(ret, "data.rs1[0].tot_rows", 0)
          this.list.items      = _.get(ret, "data.rs2", [])
        })

      // } else if (this.search.iv_gubun=='2'){

      //   ui.httpGetList(this.list
      //     , '/proc/N_VIAINFO_SEL_LIST2_BP'
      //     , {
      //       ...this.search,
      //       iv_pgsize  : this.list.listSize,
      //       iv_page    : this.list.pageNo,
      //       iv_viadtfr : this.search.iv_viadtfr.replace(/-/g, ""),
      //       iv_viadtto : this.search.iv_viadtto.replace(/-/g, ""),
      //     },
      //     ret => {
      //       this.list.totalCount = _.get(ret, "data.rs1[0].tot_rows", 0)
      //       this.list.items      = _.get(ret, "data.rs2", [])
      //     })
      // }
    },
    doReport(){
      this.reportYn = 'Y'
      let url = "/ClipReport4/via_suim_detail_front.jsp"  // via_suim_detail_front_all.crf

      let params = {
        // 레포트 출력 시, iv_pgsize를 -1로 하면 페이징 쿼리를 타지 않음.
        iv_pgsize   : -1,
        iv_page     : -1,

        iv_membclsf : this.$store.state.session.user.membclsf,
        iv_membno   : this.$store.state.session.user.membno,
        iv_membtype : this.$store.state.session.user.type,
        iv_membnos  : this.search.iv_gubun == "all" ? '-' : this.selectCustList.reduce((tot, item) => tot + '#' + item.membno, '').replace(/^#/, ""),

        // 레포트 좌상단에 표시될 이름
        iv_membnm   : this.$store.getters['session/userDpName'],

        iv_searchdtgbn : this.search.iv_searchdtgbn,
        iv_viadtfr     : this.search.iv_viadtfr,
        iv_viadtto     : this.search.iv_viadtto,
        iv_extfree_yn  : this.search.iv_extfree_yn,

        login_pers     : this.$store.state.session.user.membno
      }

      // params 객체를 urlQueryString 형식으로 변환
      let paramString = T.makeUrlQueryString(params)

      // report : url + 파라미터로 정의
      this.report = `${url}?${paramString}&r=` + Math.random()
    },

  },

}
</script>
